import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseStyle',
    standalone: true
})
export class ParseStylePipe implements PipeTransform {
    transform(value?: string): CSSStyleDeclaration | undefined {
        if (!value) {
            return;
        }

        try {
            return JSON.parse(value);
        } catch {
            console.warn('Could not parse style', value);
        }
    }
}
